<template>
  <template v-if="showHeader">
    <header>
      <div class="navbar-fixed">
        <nav>
          <div class="nav-wrapper custom-navbar">
            <router-link to="/" class="brand-logo logo-margin center z-depth-1 hide-on-small-only">&nbsp;<img src="@/assets/logo/easyhmo-50.png" width="175" />&nbsp;</router-link>
             <router-link to="/" class="brand-logo center hide-on-med-and-up">&nbsp;<img src="@/assets/logo/easyhmo-50.png" width="100" />&nbsp;</router-link>
            <!-- <router-link to="/" class="brand-logo center light-blue-text text-accent-1 hide-on-med-and-up"><b>{{ HMO }}</b></router-link> -->
            <ul class="left">
              <li>
                <a href="#!" data-target="slide-out" class="sidenav-trigger show-on-medium-and-up"><i
                    class="large material-icons">menu</i></a>
              </li>
            </ul>
            <ul class="right">
              <li class="">
                <router-link :to="{ name: 'home' }" title="Dashboard"><i
                    class="large material-icons">dashboard</i></router-link>
              </li>
              <li class="activity-bell-wrapper" v-if="activityBellEnabled">
                <a href="#!" title="Activity updates" @click.prevent="toggleActivityBell">
                  <i class="large material-icons">notifications_none</i>
                  <span class="activity-bell-count" v-if="activityTodayCount">{{ activityTodayCount }}</span>
                </a>
                <div class="activity-bell-panel" v-if="activityBellOpen">
                  <div class="activity-bell-head">
                    <div>
                      <strong>Today's Activity</strong>
                      <small>{{ activityTodayCount }} logged today</small>
                    </div>
                    <div class="activity-bell-actions">
                      <button type="button" class="activity-bell-refresh" title="Refresh activity" @click="loadActivityBellSummary(true, true)">
                        <i class="material-icons">{{ activityBellLoading ? "hourglass_empty" : "refresh" }}</i>
                      </button>
                      <button type="button" class="activity-bell-see-all" @click="openActivityFeed">
                        See all
                      </button>
                      <button type="button" class="activity-bell-cancel" @click="closeActivityBell">
                        Cancel
                      </button>
                    </div>
                  </div>
                  <div class="activity-bell-body">
                    <div class="activity-bell-empty" v-if="!activityBellLatest.length">
                      No matching activity yet.
                    </div>
                    <button
                      v-for="item in activityBellLatest"
                      :key="item.id"
                      type="button"
                      class="activity-bell-row"
                      @click="openActivityFeed"
                    >
                      <i class="material-icons">{{ activityIcon(item.event_group) }}</i>
                      <span>{{ item.display_summary || item.summary || item.title }}</span>
                      <em>{{ formatActivityDate(item.created_at) }}</em>
                    </button>
                  </div>
                  <button type="button" class="activity-bell-view-all" @click="openActivityFeed">
                    <span>Open activity feed</span>
                    <i class="material-icons">arrow_forward</i>
                  </button>
                </div>
              </li>
              <li class="hide-on-med-and-down" v-if="tabs.find(x => x.to === 'enrollee')">
                <router-link :to="{ name: 'enrollee' }" title="Enrollees"><i
                    class="large material-icons">people</i></router-link>
              </li>
              <li class="hide-on-med-and-down" v-if="tabs.find(x => x.to === 'claim')">
                <router-link :to="{ name: 'claim' }" title="Claims"><i
                    class="large material-icons">folder</i></router-link>
              </li>
              <li class="hide-on-med-and-down" v-if="tabs.find(x => x.to === 'auth')">
                <router-link :to="{ name: 'auth' }" title="Authorization"><i
                    class="large material-icons">insert_comment</i></router-link>
              </li>
            </ul>
          </div>
        </nav>
      </div>

      <!-- Side Bar -->
      <div id="slide-out" class="nav-wrapper sidenav sba-sidenav">
        <div class="sba-sidenav-profile">
          <img :src="user?.profile_img"
            class="circle responsive-img sba-sidenav-avatar" v-if="user?.profile_img" />
          <img :src="`https://ui-avatars.com/api/?name=${user?.name}&background=37474f&color=ffffff&size=128`"
            class="circle responsive-img sba-sidenav-avatar" v-else />

          <div class="sba-sidenav-user">
            <strong>{{ user?.name }}</strong>
            <small v-if="user?.designation">{{ user?.designation }}</small>
            <span v-if="user?.account?.name">{{ user?.account?.name }}</span>
          </div>
        </div>

        <div class="sba-sidenav-divider"></div>

        <ul class="sba-sidenav-list">
          <li :class="{ 'is-active': isActiveModule('home') }">
            <router-link :to="{ name: 'home' }" title="Dashboard"><i class="material-icons">dashboard</i>
              Dashboard</router-link>
          </li>

          <template v-for="tab in tabs" :key="tab.id">
            <li
              class="sba-sidenav-group"
              v-if="isReviewModule(tab.to)"
              :class="{ 'is-active': isActiveModule(tab.to) }"
            >
              <button
                type="button"
                class="sba-sidenav-group-toggle"
                :class="{ 'is-active': isActiveModule(tab.to) }"
                @click="toggleModuleMenu(tab.to)"
              >
                <span>
                  <i class="material-icons">{{ tab.icon }}</i>
                  {{ tab.title }}
                </span>
                <i class="material-icons">{{ openModuleMenus[tab.to] ? "expand_less" : "expand_more" }}</i>
              </button>

              <ul class="sba-sidenav-nested" v-if="openModuleMenus[tab.to]">
                <li
                  v-for="child in reviewModuleChildren(tab.to)"
                  :key="child.key"
                  :class="{ 'is-active': isActiveModule(tab.to) && routeSection === child.key }"
                >
                  <router-link
                    :to="{ name: tab.to, query: { section: child.key } }"
                    :title="`${tab.title} - ${child.title}`"
                  ><i class="material-icons">{{ child.icon }}</i>
                    {{ child.title }}</router-link>
                </li>
              </ul>
            </li>

            <li v-else :class="{ 'is-active': isActiveModule(tab.to) }">
              <router-link :to="{ name: tab.to }" :title="tab.title"><i class="material-icons">{{
                tab.icon }}</i>
                {{ tab.title }}</router-link>
            </li>
          </template>
        </ul>

        <ul class="sba-sidenav-list sba-sidenav-actions">
          <li @click.prevent="handleSignOut">
            <router-link :to="{ name: 'home' }" title="Logout"><i class="material-icons">power_settings_new</i>
              Logout Account</router-link>
          </li>
        </ul>
      </div>

      <!-- UI -->
      <!-- <nav class="custom-nav indigo lighten-5"></nav> -->

      <!-- Breadcrumbs -->
      <!-- <nav v-if="breadcrumbs.length">
        <div class="nav-wrapper grey">
          <div class="col s12 center">
            <router-link class="breadcrumb" to="/">Dashboard</router-link>

            <router-link
              class="breadcrumb"
              :to="index === 0 ? { name: crumb } : currentPath"
              v-for="(crumb, index) in breadcrumbs"
              :key="index"
              >{{ capitalizeFirstLetter(crumb) }}</router-link
            >
          </div>
        </div>
      </nav> -->

      <!-- <br /> -->
    </header>
  </template>
</template>

<script>
import { onMounted, onUpdated, computed, ref, watch, watchEffect } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { addModules } from "@/composables/cache/modules";
import { HMO, clientAuth, providerAuth } from '@/laravel/config';
import getItems from "@/composables/getItems";
import M from "materialize-css";

export default {
  name: "HeaderComponent",
  setup() {
    // vue router
    const router = useRouter();

    // route
    const route = useRoute();

    // store
    const store = useStore();
    const activityBellEnabled = ref(false);
    const activityBellOpen = ref(false);
    const activityBellLoading = ref(false);
    const activityTodayCount = ref(0);
    const activityBellLatest = ref([]);
    const activityBellSummaryInFlight = ref(false);
    const lastActivityBellSummaryAt = ref(0);
    const openModuleMenus = ref({});
    const reviewModuleRoutes = ["supervisor", "hod", "compliance", "finance"];
    const reviewModuleSections = {
      supervisor: [
        { key: "claims-review", title: "Claims Review", icon: "fact_check" },
        { key: "report-download", title: "Report Download", icon: "download" },
      ],
      hod: [
        { key: "claims-review", title: "Claims Review", icon: "fact_check" },
        { key: "report-download", title: "Report Download", icon: "download" },
      ],
      compliance: [
        { key: "claims-review", title: "Claims Review", icon: "fact_check" },
        { key: "invoices-payment", title: "Invoices Payment", icon: "request_quote" },
        { key: "client-approvals", title: "Client Approvals", icon: "business" },
        { key: "provider-approvals", title: "Provider Approvals", icon: "local_hospital" },
      ],
      finance: [
        { key: "claims-payment", title: "Claims Payment", icon: "payments" },
        { key: "invoices-approval", title: "Invoices Approval", icon: "receipt_long" },
        { key: "accounts", title: "Accounts", icon: "account_balance" },
      ],
    };

    // display
    const showHeader = computed(() => {
      if (route.path.includes("setup")) {
        return false;
      } else if (route.path.includes("login")) {
        return false;
      } else if (route.path.includes("utility")) {
        return false;
      } else {
        return true;
      }
    });

    // capitalize
    function capitalizeFirstLetter(val) {
      if (!val) return ''; // Handle empty strings
      return val.charAt(0).toUpperCase() + val.slice(1);
    }

    // title
    onMounted(() => {
      // menu
      const elems = document.querySelectorAll(".sidenav");
      M.Sidenav.init(elems, {});
    });

    // title
    onUpdated(() => {
      // menu
      const elems = document.querySelectorAll(".sidenav");
      M.Sidenav.init(elems, {});
    });

    // Current path
    const currentPath = computed(() => {
      let paths = route.path;
      return paths;
    });

    // Generate breadcrumbs
    const breadcrumbs = computed(() => {
      let paths = route.path.replace(/[0-9]/g, "").split("/");
      return paths.filter((x) => x);
    });

    // user
    const user = computed(() => {
      if (!store.state.user) {
        return null;
      } else {
        return store.state.user;
      }
    });

    const tabs = computed(() => {
      // load allowed
      let sourceTabs = addModules();
      // fitered
      let filteredTabs = [];
      // filter
      if (store.state.user && store.state.user.modules) {
        filteredTabs = sourceTabs.filter(x => store.state.user.modules.includes(x.to) && x.type === store.state.user.type);
      }
      // return
      return filteredTabs;
    });

    const routeModuleName = computed(() => {
      const firstPath = route.path.split("/").filter(Boolean)[0] || "home";
      const pathMap = {
        "tariff-mini": "tariffMini",
      };

      return pathMap[firstPath] || firstPath;
    });

    const isActiveModule = (name) => {
      if (name === "home") {
        return route.name === "home" || route.path === "/";
      }

      return route.name === name || routeModuleName.value === name;
    };

    const routeSection = computed(() => route.query.section || "");

    const isReviewModule = (name) => reviewModuleRoutes.includes(name);

    const reviewModuleChildren = (name) => {
      const sections = reviewModuleSections[name] || [];

      if (name !== "compliance") {
        return sections;
      }

      return sections.filter((section) => {
        if (section.key === "client-approvals") {
          return clientAuth === "compliance";
        }

        if (section.key === "provider-approvals") {
          return providerAuth === "compliance";
        }

        return true;
      });
    };

    const toggleModuleMenu = (name) => {
      openModuleMenus.value = {
        ...openModuleMenus.value,
        [name]: !openModuleMenus.value[name],
      };
    };

    const openAvailableReviewMenus = () => {
      const nextOpenMenus = { ...openModuleMenus.value };

      tabs.value
        .filter((tab) => isReviewModule(tab.to))
        .forEach((tab) => {
          if (nextOpenMenus[tab.to] === undefined) {
            nextOpenMenus[tab.to] = true;
          }
        });

      openModuleMenus.value = nextOpenMenus;
    };

    const loadActivityBellSummary = async (silent = false, force = false) => {
      if (!store.state.user) {
        activityBellEnabled.value = false;
        activityBellOpen.value = false;
        activityTodayCount.value = 0;
        activityBellLatest.value = [];
        return;
      }

      if (activityBellSummaryInFlight.value) {
        return;
      }

      const now = Date.now();

      if (!force && now - lastActivityBellSummaryAt.value < 60000) {
        return;
      }

      activityBellSummaryInFlight.value = true;

      if (!silent) {
        activityBellLoading.value = true;
      }

      try {
        const { res, err } = await getItems("activity/bell/summary");

        if (!err.value) {
          const payload = res.value?.data || {};
          activityBellEnabled.value = !!payload.enabled;
          activityTodayCount.value = payload.today_count || 0;
          activityBellLatest.value = payload.latest || [];

          if (!payload.enabled) {
            activityBellOpen.value = false;
          }
        }
      } finally {
        lastActivityBellSummaryAt.value = Date.now();
        activityBellSummaryInFlight.value = false;
        activityBellLoading.value = false;
      }
    };

    const toggleActivityBell = () => {
      activityBellOpen.value = !activityBellOpen.value;

      if (activityBellOpen.value) {
        loadActivityBellSummary(true, true);
      }
    };

    const openActivityFeed = () => {
      activityBellOpen.value = false;
      router.push({ name: "activity" });
    };

    const closeActivityBell = () => {
      activityBellOpen.value = false;
    };

    const activityIcon = (group) => {
      const icons = {
        auth: "insert_comment",
        provider: "local_hospital",
        tariff: "receipt_long",
        schedule: "view_timeline",
        client: "business",
        policy: "event_available",
        plan: "inventory_2",
        principal: "person",
        member: "badge",
        claim_batch: "fact_check",
        invoice: "request_quote",
        payment: "payments",
        repayment: "currency_exchange",
      };

      return icons[group] || "bolt";
    };

    const formatActivityDate = (value) => {
      if (!value) {
        return "";
      }

      return new Date(value).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    };

    watch(
      () => store.state.user?.id,
      () => loadActivityBellSummary(),
      { immediate: true }
    );

    watch(
      () => route.fullPath,
      () => {
        activityBellOpen.value = false;
        loadActivityBellSummary(true);

        if (isReviewModule(routeModuleName.value)) {
          openModuleMenus.value = {
            ...openModuleMenus.value,
            [routeModuleName.value]: true,
          };
        }
      }
    );

    watch(
      () => tabs.value.map(tab => tab.to).join("|"),
      () => openAvailableReviewMenus(),
      { immediate: true }
    );

    //state management
    watchEffect(() => {
      if (!store.state.user) {
        //log out
        router.push({
          name: "login",
        });
      }
    });

    // handle SignOut
    const handleSignOut = () => {
      //log out
      router.push({
        name: "logout",
      });
    };


    return {
      capitalizeFirstLetter,
      currentPath,
      breadcrumbs,
      handleSignOut,
      showHeader,
      user,
      tabs,
      openModuleMenus,
      routeSection,
      HMO: HMO,
      activityBellEnabled,
      activityBellOpen,
      activityBellLoading,
      activityTodayCount,
      activityBellLatest,
      toggleActivityBell,
      openActivityFeed,
      closeActivityBell,
      activityIcon,
      formatActivityDate,
      loadActivityBellSummary,
      isActiveModule,
      isReviewModule,
      reviewModuleChildren,
      toggleModuleMenu,
    };
  },
};
</script>

<style scoped>
.logo-margin {
  margin-top: 7px;
}

.divider-lift {
  margin-top: -12px;
}

.custom-nav {
  height: 15px;
}

.custom-navbar {
  background: linear-gradient(
    135deg,
    #3949ab 0%,   /* Indigo lighten-1 */
    #283593 40%,  /* Indigo darken-2 */
    #37474f 100%  /* Blue-grey darken-3 */
  );
  
  /* Optional polish */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

/* ===== SBA SIDENAV ===== */
.sba-sidenav {
  background: #fafafa;
  color: #263238;
  padding-bottom: 18px;
  width: 310px;
}

.sba-sidenav-profile {
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #c4d3d9;
  display: flex;
  gap: 14px;
  padding: 24px 20px 22px;
}

.sba-sidenav-avatar {
  border: 3px solid #eef3f5;
  box-shadow: none;
  flex: 0 0 auto;
  height: 58px;
  object-fit: cover;
  width: 58px;
}

.sba-sidenav-user {
  min-width: 0;
}

.sba-sidenav-user strong,
.sba-sidenav-user small,
.sba-sidenav-user span {
  display: block;
  line-height: 1.25;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sba-sidenav-user strong {
  color: #263238;
  font-size: 0.98rem;
  font-weight: 800;
}

.sba-sidenav-user small {
  color: #607d8b;
  font-size: 0.74rem;
  font-weight: 700;
  margin-top: 5px;
  text-transform: uppercase;
}

.sba-sidenav-user span {
  color: #00897b;
  font-size: 0.76rem;
  font-weight: 700;
  margin-top: 5px;
}

.sba-sidenav-divider {
  background: #e1e8eb;
  height: 1px;
  margin: 0 18px;
}

.sba-sidenav-list {
  margin: 14px 12px 0;
}

.sba-sidenav-list li {
  margin-bottom: 4px;
  position: relative;
}

.sba-sidenav-list li > a,
.sba-sidenav-group-toggle {
  align-items: center;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 8px;
  color: #455a64;
  display: flex;
  font-size: 0.9rem;
  font-weight: 700;
  gap: 12px;
  min-height: 42px;
  padding: 0 12px;
  width: 100%;
}

.sba-sidenav-list li > a {
  height: 42px;
  line-height: 42px;
}

.sba-sidenav-list li > a:hover,
.sba-sidenav-group-toggle:hover {
  background: #f1f6f7;
  border-color: #e1e8eb;
}

.sba-sidenav-list li.is-active > a,
.sba-sidenav-group-toggle.is-active {
  background: #ffffff;
  border-color: #c4d3d9;
  color: #263238;
}

.sba-sidenav-list li.is-active > a::before {
  background: #00897b;
  border-radius: 999px;
  bottom: 8px;
  content: "";
  left: -4px;
  position: absolute;
  top: 8px;
  width: 3px;
}

.sba-sidenav-list i {
  color: #37474f;
  font-size: 20px;
  line-height: 1;
  margin: 0;
  width: 24px;
}

.sba-sidenav-group-toggle {
  cursor: pointer;
  justify-content: space-between;
  line-height: 1;
}

.sba-sidenav-group-toggle span {
  align-items: center;
  display: inline-flex;
  gap: 12px;
  min-width: 0;
}

.sba-sidenav-nested {
  border-left: 1px solid #dce5e8;
  margin: 6px 0 8px 22px;
  padding-left: 9px;
}

.sba-sidenav-nested li > a {
  font-size: 0.86rem;
  min-height: 38px;
}

.sba-sidenav-actions {
  border-top: 1px solid #e1e8eb;
  margin-top: 16px;
  padding-top: 14px;
}

.sba-sidenav-actions li > a,
.sba-sidenav-actions i {
  color: #ef6c00;
}

.activity-bell-wrapper {
  position: relative;
}

.activity-bell-count {
  align-items: center;
  background: #ffca28;
  border: 2px solid #263238;
  border-radius: 999px;
  color: #263238;
  display: inline-flex;
  font-size: 0.68rem;
  font-weight: 900;
  height: 22px;
  justify-content: center;
  line-height: 1;
  min-width: 22px;
  padding: 0 5px;
  position: absolute;
  right: 3px;
  top: 8px;
}

.activity-bell-panel {
  background: #ffffff;
  border: 1px solid #cfd8dc;
  border-radius: 6px;
  box-shadow: 0 22px 44px -30px rgba(38, 50, 56, 0.72);
  color: #263238;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 92px);
  overflow: hidden;
  position: fixed;
  right: 18px;
  top: 74px;
  width: min(380px, calc(100vw - 28px));
  z-index: 1200;
}

.activity-bell-head {
  align-items: center;
  background: #fbfcfc;
  border-bottom: 1px solid #e3e8eb;
  display: flex;
  justify-content: space-between;
  padding: 14px 16px;
}

.activity-bell-head strong,
.activity-bell-head small {
  display: block;
  line-height: 1.25;
}

.activity-bell-head strong {
  color: #263238;
  font-size: 0.94rem;
  font-weight: 800;
}

.activity-bell-head small {
  color: #607d8b;
  font-size: 0.78rem;
  font-weight: 700;
  margin-top: 3px;
}

.activity-bell-actions {
  align-items: center;
  display: flex;
  gap: 7px;
}

.activity-bell-actions button {
  align-items: center;
  border: 1px solid #dce5e8;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.74rem;
  font-weight: 900;
  height: 32px;
  justify-content: center;
}

.activity-bell-actions button:hover {
  border-color: #90a4ae;
}

.activity-bell-refresh {
  background: #ffffff;
  color: #00897b;
  padding: 0;
  width: 34px;
}

.activity-bell-refresh i {
  font-size: 18px;
}

.activity-bell-see-all {
  background: #263238;
  border-color: #263238;
  color: #ffffff;
  padding: 0 12px;
}

.activity-bell-cancel {
  background: #ffffff;
  color: #607d8b;
  padding: 0 11px;
}

.activity-bell-body {
  max-height: calc(100vh - 198px);
  overflow-y: auto;
}

.activity-bell-empty {
  color: #607d8b;
  font-size: 0.88rem;
  font-weight: 700;
  padding: 16px;
}

.activity-bell-row {
  align-items: start;
  background: #ffffff;
  border: 0;
  border-bottom: 1px solid #edf1f3;
  color: #263238;
  cursor: pointer;
  display: grid;
  gap: 11px;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  padding: 13px 16px;
  text-align: left;
  width: 100%;
}

.activity-bell-row:hover {
  background: #f7fafb;
}

.activity-bell-row i {
  align-items: center;
  background: #eef7f6;
  border: 1px solid #cae4e0;
  border-radius: 6px;
  color: #00897b;
  display: inline-flex;
  font-size: 18px;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.activity-bell-row span {
  color: #263238;
  display: block;
  font-size: 0.86rem;
  font-weight: 700;
  line-height: 1.4;
}

.activity-bell-row em {
  color: #78909c;
  font-size: 0.72rem;
  font-style: normal;
  font-weight: 800;
  white-space: nowrap;
}

.activity-bell-view-all {
  align-items: center;
  background: #ffffff;
  border: 0;
  color: #263238;
  cursor: pointer;
  display: flex;
  font-size: 0.84rem;
  font-weight: 900;
  justify-content: space-between;
  padding: 13px 16px;
  width: 100%;
}

.activity-bell-view-all:hover {
  background: #f1f8f7;
}

.activity-bell-view-all i {
  color: #00897b;
  font-size: 18px;
}

@media only screen and (max-width: 992px) {
  .sba-sidenav {
    width: min(310px, calc(100vw - 28px));
  }

  .sba-sidenav-list li > a,
  .sba-sidenav-group-toggle {
    min-height: 44px;
  }

  .sba-sidenav-list li > a {
    height: auto;
    line-height: 1.25;
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .sba-sidenav-group-toggle {
    padding-bottom: 10px;
    padding-top: 10px;
  }
}

@media only screen and (max-width: 600px) {
  .custom-navbar {
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.22);
  }

  .custom-navbar .brand-logo img {
    max-width: 96px;
  }

  .custom-navbar ul.left a,
  .custom-navbar ul.right a {
    padding-left: 10px;
    padding-right: 10px;
  }

  .custom-navbar i.large {
    font-size: 25px;
  }

  .custom-navbar .activity-bell-wrapper {
    margin-right: 10px;
  }

  .custom-navbar .activity-bell-wrapper > a {
    padding-right: 12px;
  }

  .activity-bell-count {
    right: 2px;
    top: 7px;
  }

  .activity-bell-panel {
    left: 12px;
    max-height: calc(100vh - 76px);
    right: 12px;
    top: 64px;
    width: auto;
  }

  .activity-bell-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .activity-bell-actions {
    width: 100%;
  }

  .activity-bell-see-all,
  .activity-bell-cancel {
    flex: 1 1 auto;
  }

  .activity-bell-body {
    max-height: calc(100vh - 238px);
  }

  .activity-bell-row {
    grid-template-columns: 32px minmax(0, 1fr);
  }

  .activity-bell-row em {
    grid-column: 2;
  }

  .sba-sidenav-profile {
    gap: 12px;
    padding: 20px 18px;
  }

  .sba-sidenav-avatar {
    height: 52px;
    width: 52px;
  }

  .sba-sidenav-list {
    margin-left: 10px;
    margin-right: 10px;
  }

  .sba-sidenav-nested {
    margin-left: 18px;
  }
}
</style>
